import { motion } from "framer-motion"
import styled from "styled-components"

export const FiltersWrap = styled.div`
	--pad: 17px;
	--accent: #01924f;
	--cb-size: 18px;

	display: grid;
	max-width: 370px;
	margin: 12px 0 20px;
	padding: var(--pad);
	border: 1px solid #e6e6e9;
	border-radius: 12px;
	background: #fbfbfd;
`

export const Title = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 13px;
	line-height: 122%;
	letter-spacing: 0.01em;
	text-transform: uppercase;
	color: #484848;
    margin-bottom: 20px;

	backface-visibility: hidden;
	transform-style: preserve-3d;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;


	display: flex;
	align-items: center;
	justify-content: space-between;

	border-bottom: 1px solid #d9d9d9;

	svg {
		cursor: pointer;
	}
`

export const Actions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 15px;
	padding: 0 10px;
`
export const Overlay = styled(motion.div)`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.4);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
`

export const Drawer = styled(motion.aside)`
	position: fixed;	
	right: 0;
	left: auto;
	width: min(420px, 100vw);

	top: 0;
	height: 100vh;

	z-index: 1001;

	display: flex;
	flex-direction: column;
	overflow: auto;
	will-change: transform;

	transform: translateZ(0);
	backface-visibility: hidden;
	-webkit-font-smoothing: antialiased;
`

export const SelectedCount = styled.span`
  color: #01924f;          
  font-weight: 600;
  margin-left: 6px;
`;

interface IFilterButtonProps {
  $variant?: 'filled' | 'outline';
}

export const FilterButton = styled.button<IFilterButtonProps>`
  width: 100%; 
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 0; 
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  font-family: "e-Ukraine", sans-serif;
  font-weight: 400;
  font-size: 14px; 
  line-height: 122%;
  letter-spacing: -0.01em;
  text-align: center;

  background: ${({ $variant }) => ($variant === 'outline' ? 'transparent' : '#01924f')};
  color: ${({ $variant }) => ($variant === 'outline' ? '#333333' : '#ffffff')};
  border: ${({ $variant }) => ($variant === 'outline' ? '1px solid #474747' : '1px solid transparent')};

  &:hover {
    opacity: 0.9;
    background: ${({ $variant }) => ($variant === 'outline' ? 'rgba(0, 0, 0, 0.02)' : '#01924f')};
  }
`;